export default __webpack_public_path__ + "static/media/quarto.a49a7df6.jpeg";